import React from "react"
import { InternalHeaderContainer, TitleWrapper } from "./style"
import AvenueImg from "components/AvenueImg"

const InternalHeader = ({ title, featuredImage }) => {
  return (
    <InternalHeaderContainer>
      {featuredImage && <AvenueImg fluid={featuredImage} />}
      <TitleWrapper>
        <h1 dangerouslySetInnerHTML={{ __html: title }} />
      </TitleWrapper>
    </InternalHeaderContainer>
  )
}

export default InternalHeader
